import { derived, writable } from "svelte/store";
import { featureEnabled } from "../features";
import { response } from "../global";

export const suggestedQuestions = writable(null);

export const displaySuggestedQuestions = writable(false);

export const suggestedQuestionsSheetOpen = writable(false);

export const suggestedQuestionsOnScreen = derived(
  [suggestedQuestions, displaySuggestedQuestions],
  ([$suggestedQuestions, $displaySuggestedQuestions]) =>
    Array.isArray($suggestedQuestions) &&
    $suggestedQuestions.length > 0 &&
    $displaySuggestedQuestions
);

export const suggestedQuestionsTimerCancelled = writable(false);

/**
 * Reset suggested questions to null and set
 * display to false
 */
export function resetSuggestedQuestions() {
  suggestedQuestions.update(() => null);
  displaySuggestedQuestions.update(() => false);
  suggestedQuestionsTimerCancelled.update(() => false);
}

response.subscribe((data = {}) => {
  suggestedQuestionsTimerCancelled.update(() => false);
  if (
    data.payload &&
    data.payload.features &&
    featureEnabled("suggested-questions")
  ) {
    const suggestedQuestionsFeature = data.payload.features.find(
      (feature) => feature.type === "suggested-questions"
    );
    if (
      suggestedQuestionsFeature &&
      suggestedQuestionsFeature.payload &&
      suggestedQuestionsFeature.payload.length
    ) {
      suggestedQuestions.update(() => suggestedQuestionsFeature.payload);
    } else {
      resetSuggestedQuestions();
    }
  } else {
    resetSuggestedQuestions();
  }
});
